import {Command} from 'substance'
import SourceComponent from './NewsMLSourceComponent'

class NewsMLSourceCommand extends Command {

    getCommandState() {
        return true
    }

    execute(params) {
        if (!params.editorSession.saveHandler) {
            return
        }

        const xml = params.editorSession.saveHandler.getExportedDocument()
        params.api.ui.showDialog(SourceComponent, {xml: xml}, {
            title: 'Source',
            primary: 'Ok',
            secondary: false,
            takeover: true
        })
    }
}

export default NewsMLSourceCommand
